<template>
	<div class="list-container column">
		<div class="title">{{ $t('fire_protection_list.title') }}</div>
		<div class="switchbutton-wrapper">
			<SwitchButton
				class="switchbutton"
				v-for="id in fireProtectionGroupIds"
				:key="id"
				:label="$t(`fire_protection_group.${id}`)"
				:value="searchParams.FireProtectionType === id"
				@input="toggleGroup(id)"
			/>
		</div>
		<div class="panel-list-header">
			<div class="panel-filler-icon" />
			<div class="panel-header-item">{{ $t('fire_protection_list.name') }}</div>
			<div v-if="!isMobile" class="panel-header-item">{{ $t('fire_protection_list.type') }}</div>
			<div v-if="!isMobile" class="panel-header-item">{{ $t('fire_protection_list.group') }}</div>
			<div class="panel-filler" />
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="fireProtection in fireProtections"
			:key="fireProtection.id"
			:class="fireProtection.id == activeFireProtection.id ? 'active' : ''"
			@click="onSelect(fireProtection)"
		>
			<div class="panel-list-item special">
				<div
					class="fireprotection-icon"
					:class="getType(fireProtection.inventoryType)?.icon"
				></div>
			</div>

			<div class="panel-list-item" :title="displayFPName(fireProtection)">
				{{ displayFPName(fireProtection) }}
			</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ tTypeKey(fireProtection.inventoryType) }}
			</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ tGroup(fireProtection.fireProtectionType) }}
			</div>
			<div class="list-button" @click.stop="onEdit(fireProtection)">
				<i class="fas fa-edit"></i>
			</div>
			<div class="list-button" @click.stop="onDelete(fireProtection)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="fireProtections.length == 0">
			<p class="panel-list-item">{{ $t('fire_protection_list.no_results') }}</p>
		</div>
		<Pagination
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import iconMixin from '@/mixins/iconMixin.js';
import SwitchButton from '@/components/switchButton';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
	mixins: [iconMixin],
	components: {
		Pagination,
		SwitchButton
	},
	props: {
		fireProtections: Array,
		activeFireProtection: Object
	},
	data: () => ({
	}),
	computed: {
		...mapState('fireProtectionStore', ['searchParams']),
		...mapGetters('fireProtectionStore', ['pagination']),
		...mapGetters('appStore', ['isMobile']),
		fireProtectionGroupIds() {
			return [0, 1, 2, 3, 4, 5];
		}
	},
	methods: {
		...mapActions('fireProtectionStore', ['setCurrentPage', 'setPageSize']),

		toggleGroup(id) {
			if (this.searchParams.FireProtectionType === id) {
			delete this.searchParams.FireProtectionType;
			} else {
			this.searchParams.FireProtectionType = id;
			}
			this.$emit('search');
		},

		onDelete(fireProtection) {
			this.$emit('delete', fireProtection);
		},

		onEdit(fireProtection) {
			this.$emit('edit', fireProtection);
		},

		onSelect(fireProtection) {
			if (!this.isMobile) {
			this.$emit('select', fireProtection);
			}
		},

		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},

		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		},

		tGroup(id) {
			if (id === null || id === undefined || id === -1) {
			return this.$t('add_fire_protection.not_selected');
			}
			return this.$t(`fire_protection_group.${id}`);
		}
	},
	created() {
		this.fireProtectionGroupMap = Object.values(
			this.getFireProtectionGroupMap()
		).map((item, index) => {
			return { index, text: item, isChecked: false };
		});
	},
	beforeDestroy() {
		delete this.searchParams.FireProtectionType;
	}
	};
</script>

<style lang="scss" scoped>
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.fireprotection-icon {
  background-color: white;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
}

.switchbutton-wrapper {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;

  .switchbutton {
    font-weight: 600;
    margin-right: 10px;
    text-align: center;
	display: flex;
	flex-direction: column;
  }
}
</style>
